import styled from "styled-components";

export const CardArea = styled.div`
  max-width: 50rem;
  min-width: 30rem;
  background: white;
  border-radius: 0.5rem;
  display: flex;
  margin: 1.5rem;
  box-shadow: 1px black;
  align-items: center;
  box-shadow: rgba(79, 78, 78, 0.522) 1px 0.1px 10px;
`;

export const Image = styled.img`
  height: 11rem;
  width: 15rem;
  padding: 13px;
  border-radius: 1.3rem;
`;

export const TextArea = styled.div`
  display: flex;
  flex-direction: column;
`;
